export const awsconfig = {
    "Auth": {
      "region": process.env.VUE_APP_REGION,
      "userPoolId": process.env.VUE_APP_USERPOOL_ID,
      "userPoolWebClientId": process.env.VUE_APP_APP_CLIENT_ID,
    },
  };

  